/* eslint react/jsx-no-bind: 0 */
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useMe } from '../../../contexts/me'
import { getFileByFilename } from '../../../helpers/helper-file'
import Icon from '../../icon'
import { If } from '../../if/if'

import {
  Container,
  ProfileWrapper,
  Profile,
  PhotoWrapper,
  InfoWrapper,
  Username,
  Role,
  ArrowWrapper,
  Dropdown,
  Name,
} from './styles'

const HeaderDashboard = () => {
  const { me } = useMe()
  const history = useHistory()
  const [logo, setLogo] = useState<string | null>(null)
  const [dropdownIsOpen, setDropdownIsOpen] = useState(false)

  function getProfile(profiles: any) {
    if (!me) return ''
    let greatestPermissionsId: any = null
    let greatestPermissionsAmount = 0
    profiles.forEach((profile: any) => {
      if (greatestPermissionsAmount < profile.permissions.length) {
        greatestPermissionsId = profile.id
        greatestPermissionsAmount = profile.length
      }
    })
    const profileSelected = profiles.find((profile: any) => profile.id === greatestPermissionsId)
    return profileSelected?.name ?? ''
  }

  function toggleDropdown() {
    setDropdownIsOpen((state) => !state)
  }

  function handleLogout() {
    localStorage.clear()
    history.push('/')
  }

  const getFirstName = () => me?.fullname.split(' ')[0]

  useEffect(() => {
    function loadComponent() {
      if (!me) return
      const { file } = me.stablishments[0]

      if (file) {
        const filename = file?.filename
        setLogo(getFileByFilename(filename))
      }
    }

    loadComponent()
  }, [logo, me])

  if (!me) return null

  return (
    <Container>
      <If condition={logo}>
        <img src={String(logo)} alt=" " />
      </If>
      <If condition={!logo}>
        <Name>{me.stablishments[0].name}</Name>
      </If>

      <Profile>
        <ProfileWrapper onClick={toggleDropdown}>
          <PhotoWrapper>
            <Icon name="user" />
          </PhotoWrapper>

          <InfoWrapper>
            <Username>{getFirstName()}</Username>
            <Role>{getProfile(me.profiles)}</Role>
          </InfoWrapper>

          <ArrowWrapper>
            <Icon name="arrow-down" style={{ color: '#000' }} />
          </ArrowWrapper>
        </ProfileWrapper>

        <Dropdown style={{ display: dropdownIsOpen ? 'flex' : 'none' }}>
          <button type="button" onClick={handleLogout}>Sair</button>
        </Dropdown>
      </Profile>
    </Container>
  )
}

export default HeaderDashboard
